import type { ChangeStats } from '../types/app';

export function createStats(): ChangeStats {
  return {
    duplicateSpacesRemoved: 0,
    blankLinesReduced: 0,
    nbspNormalized: 0,
    specialSpacesNormalized: 0,
    invisibleCharsRemoved: 0,
    softHyphensRemoved: 0,
    lineBreaksRepaired: 0,
    hyphenationsJoined: 0,
    listsConverted: 0,
    punctuationSpacesFixed: 0,
    markdownConversions: 0,
    unsafeHtmlRemoved: 0,
    stylePhrasesRewritten: 0,
  };
}

const labels: Array<[keyof ChangeStats, string, string]> = [
  ['lineBreaksRepaired', 'harter Zeilenumbruch repariert', 'harte Zeilenumbrüche repariert'],
  ['hyphenationsJoined', 'Silbentrennung zusammengeführt', 'Silbentrennungen zusammengeführt'],
  ['duplicateSpacesRemoved', 'überflüssiges Leerzeichen entfernt', 'überflüssige Leerzeichen entfernt'],
  ['blankLinesReduced', 'überflüssige Leerzeile entfernt', 'überflüssige Leerzeilen entfernt'],
  ['nbspNormalized', 'geschütztes Leerzeichen normalisiert', 'geschützte Leerzeichen normalisiert'],
  ['specialSpacesNormalized', 'Sonderleerzeichen normalisiert', 'Sonderleerzeichen normalisiert'],
  ['invisibleCharsRemoved', 'unsichtbares Zeichen entfernt', 'unsichtbare Zeichen entfernt'],
  ['softHyphensRemoved', 'weiches Trennzeichen entfernt', 'weiche Trennzeichen entfernt'],
  ['listsConverted', 'Liste erkannt', 'Listen erkannt'],
  ['punctuationSpacesFixed', 'Satzzeichenabstand korrigiert', 'Satzzeichenabstände korrigiert'],
  ['markdownConversions', 'Markdown-Formatierung umgewandelt', 'Markdown-Formatierungen umgewandelt'],
  ['unsafeHtmlRemoved', 'unsicheres HTML-Element oder Attribut entfernt', 'unsichere HTML-Elemente oder Attribute entfernt'],
  ['stylePhrasesRewritten', 'Stiländerung natürlicher formuliert', 'Stiländerungen natürlicher formuliert'],
];

export function formatStats(stats: ChangeStats): string[] {
  return labels.flatMap(([key, singular, plural]) => {
    const count = stats[key];
    return count > 0 ? [`${count} ${count === 1 ? singular : plural}`] : [];
  });
}

export function totalChanges(stats: ChangeStats): number {
  return Object.values(stats).reduce((sum, value) => sum + value, 0);
}
